import React, { useContext } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";

export const MergeAcntInfo = () => {
  const { userinfo } = useContext(AppContext);

  return (
    <WhiteDiv>
      <Title>통합계정정보</Title>
      <DataArea>
        <DataLine>
          <DataTitle>아이디</DataTitle>
          <DataInfo>{userinfo.userEmail}</DataInfo>
        </DataLine>

        <DataLine>
          <DataTitle>휴대폰번호</DataTitle>
          <DataInfo>{userinfo.userPhone}</DataInfo>
        </DataLine>
      </DataArea>
    </WhiteDiv>
  );
};

const WhiteDiv = styled.div`
  display: flex;
  padding: 16px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 10px;
  background: #fafafa;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const DataArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const DataLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const DataTitle = styled.div`
  color: #888;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const DataInfo = styled.div`
  color: #333;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;
